import { FC, useState, useEffect } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ModalComponent } from 'components/Modal';
import { pageTypeButtons } from 'views/Pages/constants';
import { DashboardScreen, PageCategory, trackEvent } from 'helpers/mixpanelEvents';

interface Props {
  handleDelete?: () => void;
  popupType: string;
  isOpen: boolean;
  closePopup: () => void;
  subscriptionLevel: string;
  screen: DashboardScreen;
  pageCategory: string;
}

export const PageModal: FC<Props> = ({
  handleDelete,
  popupType,
  isOpen,
  closePopup,
  subscriptionLevel,
  screen,
  pageCategory,
}) => {
  const navigate = useNavigate();
  const [pageTypeSelected, setPageTypeSelected] = useState('');

  useEffect(() => {
    if (!isOpen) setPageTypeSelected('');
  }, [isOpen]);

  const handleSelectPageType = (type: string) => {
    trackEvent('Create Page Type Selected', {
      screen,
      page_category: pageCategory as PageCategory,
      selected_type: type as PageCategory,
    });
    setPageTypeSelected(type);
  };

  const handleCreatePage = () => {
    if (!pageTypeSelected) return;
    trackEvent('Create Page Confirmed', {
      screen,
      page_category: pageCategory as PageCategory,
      selected_type: pageTypeSelected as PageCategory,
    });
    if (pageTypeSelected === 'community') {
      navigate(`/community_pages_detail?page_type=${pageTypeSelected}`);
    } else {
      navigate(`/pages_detail?page_type=${pageTypeSelected}`);
    }
  };

  const handleCancel = () => {
    trackEvent(popupType === 'create' ? 'Create Page Canceled' : 'Delete Page Canceled', {
      screen,
      page_category: pageCategory as PageCategory,
    });
    closePopup();
  };

  return (
    <ModalComponent isOpen={isOpen} closeModal={handleCancel}>
      <div className="grid-column">
        {popupType === 'create' ? (
          <>
            <span className="create-page-title">Create a Page</span>
            <span className="oath-body inkBlue">Select the type of page you want to create:</span>
            {pageTypeButtons
              .filter(page =>
                subscriptionLevel !== 'PREMIUM' ? page.type !== 'recommendation' : page
              )
              .map(page => (
                <button
                  type="button"
                  key={page.type}
                  className={classNames('popup-new-page', {
                    active: pageTypeSelected === page.type,
                  })}
                  onClick={() => handleSelectPageType(page.type)}
                >
                  <img src={page.img} alt={page.type} />
                  <div className="grid-column">
                    <span className="oath-eyebrow inkBlue">{page.title}</span>
                    <span className="oath-bodysmall inkBlue">{page.description}</span>
                  </div>
                </button>
              ))}
            <button
              type="button"
              className="btn-inkBlue btn btn-secondary"
              onClick={handleCreatePage}
            >
              Confirm
            </button>
          </>
        ) : (
          <>
            <span className="oath-eyebrow inkBlue">Delete Page</span>
            <span className="oath-body inkBlue">
              Are you sure you would like to delete this page? This can&apos;t be undone.
            </span>
            <button type="button" className="btn-inkBlue btn btn-secondary" onClick={handleDelete}>
              Delete
            </button>
          </>
        )}
        <button
          type="button"
          className="oath-bodysmall link-text gray padding0"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </ModalComponent>
  );
};
